import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

export interface SpecsFiltersType {
    verticals: string[];
    product: string[];
}
const verticalsList = ["All", "Insurance", "Home Services", "Legal", "Debt", "Travel", "Other"]
interface SpecsFiltersProps {
    value: SpecsFiltersType;
    onChange: (filters: SpecsFiltersType) => void;
    onApply: (filters: Record<string, any>) => void;
    onClose: () => void;
}
export function SpecsFilters({
    value,
    onChange,
    onApply,
    onClose,
}: SpecsFiltersProps) {

    const filters = value;

    const clearFilters = () =>
        onChange({
            ...filters,
            verticals: [],
        });

    const applyFilters = () => {
        const params: Record<string, any> = {};

        if (filters.verticals.length > 0) {
            params.verticals = [...filters.verticals];
        }
        onApply(params);
        onClose();
    };
    const handleVerticalToggle = (type: "Calls" | "Leads" | "Traffic") =>
        onChange({
            ...filters,
            verticals: filters.verticals.includes(type)
                ? filters.verticals.filter((t) => t !== type)
                : [...filters.verticals, type],
        });

    return (
        <div className="absolute top-full right-0 mt-2 w-80 bg-white rounded-xl shadow-lg border border-gray-200 z-30">
            <div className="p-4">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-[#333]">Filters</h3>
                    <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
                        <MdClose size={20} />
                    </button>
                </div>

                <div className="mb-6">
                    <h4 className="text-sm font-semibold text-[#606060] mb-3">Verticals</h4>
                    <div className="space-y-2">
                        {verticalsList.map((type) => (
                            <label key={type} className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={filters.verticals.includes(type as any)}
                                    onChange={() => handleVerticalToggle(type as any)}
                                    className="mr-3 rounded border-gray-300 text-[#F97316] focus:ring-[#F97316]"
                                />
                                <span className="text-sm text-[#333]">{type}</span>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="flex gap-3">
                    <button
                        onClick={clearFilters}
                        className="flex-1 px-4 py-2 text-sm font-medium text-[#606060] border border-gray-300 rounded-lg hover:bg-gray-50"
                    >
                        Clear All
                    </button>
                    <button
                        onClick={applyFilters}
                        className="flex-1 px-4 py-2 text-sm font-medium bg-[#F97316] text-white rounded-lg hover:bg-orange-600"
                    >
                        Apply
                    </button>
                </div>
            </div >
        </div >
    );
}
